import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { AxiosError } from 'axios'

import showErrorToast from '@/common/utils/showErrorToast'
import useMutationCreateCommission from '@/modules/promotion/api/hooks/useMutateCreateCommission'
import { CreateCommissionCashbackRequest } from '@/modules/promotion/type'
import CommissionForm from '../../../CommissionForm'
import { ProviderResolutionConflictDialog } from '../../../ProviderResolutionConflictDialog'

export default function CreateCommissionForm() {
	const navigate = useNavigate()
	const [conflictDialogOpen, setConflictDialogOpen] = useState(false)
	const [conflictMessage, setConflictMessage] = useState('')

	const { mutate: createCommission } = useMutationCreateCommission({
		onSuccess: () => {
			toast.success('สร้างกิจกรรมคอมมิชชั่นสำเร็จ')
			navigate('/operator/commission')
		},
		onError: (error) => {
			const axiosError = error as unknown as AxiosError<{
				message: string
				errorCode: string
			}>

			// Check if it's a provider resolution conflict error
			if (
				axiosError.isAxiosError &&
				axiosError.response?.data?.errorCode === 'PROVIDER_RESOLUTION_CONFLICT'
			) {
				setConflictMessage(axiosError.response.data.message)
				setConflictDialogOpen(true)
				return
			}

			// For other errors, show toast
			showErrorToast(error)
		},
	})

	const handleSubmit = (payload: CreateCommissionCashbackRequest) => {
		createCommission({ payload })
	}

	return (
		<>
			<CommissionForm mode="create" onSubmit={handleSubmit} />
			<ProviderResolutionConflictDialog
				isOpen={conflictDialogOpen}
				onClose={() => setConflictDialogOpen(false)}
				message={conflictMessage}
			/>
		</>
	)
}
